module.exports = __webpack_public_path__ + "static/media/globe.d2faf797.svg";